export const svgAiLibrary = {};
